const EAT_TZ = 'Africa/Dar_es_Salaam';
export const eatNow = () => new Date(new Date().toLocaleString('en-US', { timeZone: EAT_TZ }));
export const eatOpenToday = () => {
  const now = eatNow();
  const open = new Date(now);
  open.setHours(9, 30, 0, 0);
  return open;
};
export const fmtHHmm = (ts: number) => {
  const d = new Date(ts);
  return d.toLocaleTimeString('en-US', { timeZone: EAT_TZ, hour: '2-digit', minute: '2-digit', hour12: false });
};
export const sameEatDay = (ts: number) => {
  const d = new Date(ts), n = eatNow();
  return d.getFullYear() === n.getFullYear() &&
         d.getMonth() === n.getMonth() &&
         d.getDate() === n.getDate();
};

// Convert various timestamp formats (FIX/ISO/HH:mm:ss) to EAT HH:mm:ss string
export function toEAT(ts?: string | number | Date | null): string {
  if (!ts) return '';
  // Convert to string if it's not already
  let tsStr: string;
  if (typeof ts === 'string') {
    tsStr = ts;
  } else if (typeof ts === 'number') {
    tsStr = new Date(ts).toISOString();
  } else if (ts instanceof Date) {
    tsStr = ts.toISOString();
  } else {
    tsStr = String(ts);
  }
  const eatOffsetMinutes = 3 * 60;
  const fixHeaderMatch = tsStr.match(/^(\d{4})(\d{2})(\d{2})-(\d{2}):(\d{2}):(\d{2})(\.\d+)?$/);
  if (fixHeaderMatch) {
    const [, Y, M, D, h, m, s] = fixHeaderMatch;
    let d = new Date(Date.UTC(+Y, +M - 1, +D, +h, +m, +s));
    d = new Date(d.getTime() + eatOffsetMinutes * 60 * 1000);
    const hh = String(d.getUTCHours()).padStart(2, '0');
    const mm = String(d.getUTCMinutes()).padStart(2, '0');
    const ss = String(d.getUTCSeconds()).padStart(2, '0');
    return `${hh}:${mm}:${ss} EAT`;
  }
  const timeMatch = tsStr.match(/^(\d{2}):(\d{2}):(\d{2})(\.\d+)?$/);
  if (timeMatch) {
    const [, h, m, s] = timeMatch;
    const now = new Date();
    const base = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), +h, +m, +s));
    const eat = new Date(base.getTime() + eatOffsetMinutes * 60 * 1000);
    const hh = String(eat.getUTCHours()).padStart(2, '0');
    const mm = String(eat.getUTCMinutes()).padStart(2, '0');
    const ss = String(eat.getUTCSeconds()).padStart(2, '0');
    return `${hh}:${mm}:${ss} EAT`;
  }
  // ISO
  const d = new Date(tsStr.endsWith('Z') ? tsStr : tsStr + 'Z');
  if (!isNaN(+d)) {
    const eat = new Date(d.getTime() + eatOffsetMinutes * 60 * 1000);
    const hh = String(eat.getUTCHours()).padStart(2, '0');
    const mm = String(eat.getUTCMinutes()).padStart(2, '0');
    const ss = String(eat.getUTCSeconds()).padStart(2, '0');
    return `${hh}:${mm}:${ss} EAT`;
  }
  return `${tsStr} EAT`;
}

export function parseMsFromTs(ts?: string | number | Date | null): number {
  if (!ts) return 0;
 
  // Convert to string if it's not already
  let tsStr: string;
  if (typeof ts === 'string') {
    tsStr = ts;
  } else if (typeof ts === 'number') {
    // If it's a Unix timestamp (seconds), convert to milliseconds
    if (ts < 1e12) {
      return ts * 1000;
    }
    // Already in milliseconds
    return ts;
  } else if (ts instanceof Date) {
    return ts.getTime();
  } else {
    tsStr = String(ts);
  }
  
  const fixHeaderMatch = tsStr.match(/^(\d{4})(\d{2})(\d{2})-(\d{2}):(\d{2}):(\d{2})(\.\d+)?$/);
  if (fixHeaderMatch) {
    const [, Y, M, D, h, m, s] = fixHeaderMatch;
    return Date.UTC(+Y, +M - 1, +D, +h, +m, +s);
  }
  const timeMatch = tsStr.match(/^(\d{2}):(\d{2}):(\d{2})(\.\d+)?$/);
  if (timeMatch) {
    const [, h, m, s] = timeMatch;
    const now = new Date();
    return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), +h, +m, +s);
  }
  const d = new Date(tsStr.endsWith('Z') ? tsStr : tsStr + 'Z');
  return isNaN(+d) ? 0 : +d;
}
